{
  "WHATSAPP_TEMPLATE_MGMT": {
    "TITLE": "Шаблоны",
    "DESCRIPTION": "Просмотр шаблонов сообщений, синхронизированных из ваших источников WhatsApp. Создать или изменить шаблон можно у вашего провайдера.",
    "COUNT": "Количество шаблонов: {n}",
    "LEARN_MORE": "Узнать больше о шаблонах WhatsApp",
    "SYNC_TEMPLATES": "Синхронизировать шаблоны",
    "SYNC_SUCCESS": "Синхронизация шаблонов запущена для всех источников WhatsApp. Обновление может занять пару минут.",
    "PARTIAL_SYNC_ERROR": "Синхронизация шаблонов запущена для части источников WhatsApp, но для остальных синхронизация не удалась.",
    "SYNC_ERROR": "Не удалось запустить синхронизацию шаблонов. Пожалуйста, попробуйте еще раз.",
    "SEARCH_PLACEHOLDER": "Поиск по содержанию или названию...",
    "MANAGE_IN_META": "Управлять в Meta",
    "LOADING": "Загрузка шаблонов WhatsApp...",
    "EMPTY": "Шаблоны WhatsApp не найдены.",
    "NO_RESULTS": "Нет шаблонов, соответствующих выбранным фильтрам.",
    "FETCH_ERROR": "Не удалось загрузить шаблоны WhatsApp. Пожалуйста, попробуйте еще раз.",
    "PARTIAL_FETCH_ERROR": "Некоторые шаблоны WhatsApp не удалось загрузить. Пожалуйста, попробуйте еще раз.",
    "LAST_SYNC_ATTEMPT": "Последняя попытка синхронизации: {date}",
    "MORE_INBOXES": "+{n}",
    "STATUSES": {
      "UNSUBMITTED": "Не отправлено на одобрение WhatsApp"
    },
    "FILTERS": {
      "ALL_INBOXES": "Все источники",
      "ALL_LANGUAGES": "Все языки",
      "ALL_TYPES": "Все типы"
    },
    "TYPES": {
      "TEXT": "Текст",
      "IMAGE": "Изображение",
      "VIDEO": "Видео",
      "DOCUMENT": "Документ",
      "CALL_TO_ACTION": "Призыв к действию",
      "COPY_CODE": "Копировать код"
    },
    "PREVIEW": {
      "TITLE": "Предпросмотр шаблона",
      "DESCRIPTION": "Посмотрите, как этот шаблон выглядит в WhatsApp.",
      "OPEN": "Предпросмотр {name}",
      "CLOSE": "Закрыть предпросмотр",
      "DETAILS": "Детали шаблона",
      "STATUS": "Статус",
      "TYPE": "Тип содержимого",
      "CATEGORY": "Категория",
      "LANGUAGE": "Язык",
      "INBOXES": "Источники"
    }
  }
}
